import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (data.success) {
        setSent(true);
      } else {
        setError(data.message || 'Ошибка');
      }
    } catch {
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '14px 16px',
    background: 'rgba(255, 255, 255, 0.06)',
    border: '1px solid rgba(212, 175, 55, 0.25)',
    borderRadius: '12px',
    color: '#fff',
    fontSize: '16px',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.3s',
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a2e 100%)',
      padding: '20px',
    }}>
      <div style={{
        background: 'rgba(13, 20, 40, 0.85)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(212, 175, 55, 0.12)',
        borderRadius: '24px',
        padding: '50px 40px',
        maxWidth: '460px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
        position: 'relative',
      }}>
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />

        {!sent ? (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔑</div>
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              fontSize: '28px',
              fontWeight: 'bold',
              marginBottom: '12px',
              background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              Восстановление пароля
            </h1>
            <p style={{ color: '#999', fontSize: '15px', lineHeight: '1.6', marginBottom: '30px' }}>
              Введите email, указанный при регистрации. Мы отправим ссылку для установки нового пароля.
            </p>

            {error && (
              <div style={{
                background: 'rgba(220, 53, 69, 0.15)',
                border: '1px solid rgba(220, 53, 69, 0.4)',
                color: '#ff6b6b',
                padding: '12px 16px',
                borderRadius: '12px',
                marginBottom: '20px',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px', textAlign: 'left' }}>
                <label style={{ display: 'block', color: '#d4af37', marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="example@mail.ru"
                  style={inputStyle}
                  onFocus={(e) => { e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.6)'; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.25)'; }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: loading ? 'rgba(212, 175, 55, 0.3)' : 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                  border: 'none',
                  borderRadius: '12px',
                  color: '#0a0a1a',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s',
                  fontFamily: 'var(--font-sans)',
                }}
              >
                {loading ? 'Отправка...' : 'Отправить ссылку'}
              </button>
            </form>

            <div style={{ marginTop: '24px', fontSize: '14px' }}>
              <Link to="/login" style={{ color: '#4fd1c5', textDecoration: 'none' }}>
                ← Вернуться ко входу
              </Link>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>✉️</div>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              fontSize: '26px',
              fontWeight: 'bold',
              marginBottom: '16px',
              background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              Письмо отправлено!
            </h2>
            <p style={{ color: '#ccc', fontSize: '15px', lineHeight: '1.7', marginBottom: '12px' }}>
              Если аккаунт с адресом <strong style={{ color: '#4fd1c5' }}>{email}</strong> зарегистрирован,
              мы отправили ссылку для восстановления пароля.
            </p>
            <p style={{ color: '#888', fontSize: '14px', lineHeight: '1.6', marginBottom: '30px' }}>
              Проверьте папку «Входящие» и «Спам». Ссылка действительна 1 час.
            </p>

            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '14px 40px',
                background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                border: 'none',
                borderRadius: '12px',
                color: '#0a0a1a',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                fontFamily: 'var(--font-sans)',
              }}
            >
              Вернуться ко входу
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
